import React from 'react';

import { ICardAreasProps } from './interface';
import { getClassTextTheme } from './utils';

export function Card5Content({
  data: {
    text_1,
    text_2,
    text_4,
    text_5,
    text_6,
    text_theme_1,
    text_theme_2,
    text_theme_4,
    text_theme_5,
    text_theme_6,
  },
}: Omit<ICardAreasProps, 'onClick'>) {
  return (
    <div
      className="vitrine-template2__card--link-card-line"
      data-testid="card-2-content"
    >
      <span
        className={`vitrine-template2__card--text1 ${getClassTextTheme(
          text_theme_1,
        )}`}
      >
        {text_1}
      </span>
      <span className="vitrine-template2__card--text2" />
      <hr className="vitrine-template2__card--link-card-line-line" />
      <span className="vitrine-template2__card--text4">
        <br />
        {text_4}
      </span>
      <span
        className={`vitrine-template2__card--text5 ${getClassTextTheme(
          text_theme_5,
        )}`}
      >
        {text_6}
      </span>
      <span className="vitrine-template2__card--text6" />
    </div>
  );
}
